export default __webpack_public_path__ + "static/media/sd-app-page.6b77a82a.png";